"use strict";
import { tns } from "tiny-slider";

export default function () {
    const valid = document.querySelector(".o-awards-timeline__container");
    if (valid) {
        const slider = tns({
            container: ".o-awards-timeline__container",
            slideBy: 1,
            controls: false,
            nav: true,
            navPosition: "bottom",
            gutter: 12,
            loop: true,
            items: 1,
            center: true,
            touch: true,
            mouseDrag: true,
            responsive: {
                1024: {
                    items: 3,
                },
            },
        });

        const arrowLeft = document.querySelector(".o-awards .arrows-left");
        arrowLeft.addEventListener("click", () => {
            slider.goTo("prev");
        });
        const arrowRight = document.querySelector(".o-awards .arrows-right");
        arrowRight.addEventListener("click", () => {
            slider.goTo("next");
        });
    }
}
